import { Grid,Container } from "@mui/material";
import React from "react";
import BriefsVisitor from "./sections/BriefsVisitor.jsx";
import EventsVisitor from "./sections/EventsVisitor.jsx";
import AppLayout from "../layouts/AppLayout.jsx";

const Content = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <BriefsVisitor />
      </Grid>
      <Grid item xs={12} md={6}>
        <EventsVisitor />
      </Grid>
    </Grid>
    </Container>
    
  );
};


const BriefsEvenements = () => {
    return (
        <AppLayout isShowSlider={false}>
            <Content />
        </AppLayout>
    );
};

export default BriefsEvenements;
